import React from 'react';
import { Helmet } from 'react-helmet-async';
import { useTranslation } from 'react-i18next';

// Baseline <html lang> and <title> for pages that don't render their own
// SEOHead; any page-level SEOHead mounts deeper and overrides this title.
const DefaultSEO = () => {
  const { t, i18n } = useTranslation();
  const lang = (i18n.language || 'es').split('-')[0];
  return (
    <Helmet htmlAttributes={{ lang }}>
      <title>{t('seo.defaultTitle')}</title>
    </Helmet>
  );
};

export default DefaultSEO;
